export const SET_TRIGGERS_TABLE_NAME = 'SET_TRIGGERS_TABLE_NAME';

export const setTriggersTableName = name => {
  return {
    type: SET_TRIGGERS_TABLE_NAME,
    data: name,
  };
};
